import fetch from 'isomorphic-fetch';

/**
 * Example usage:
 *
 * import fetchTimeout from './utils/fetch-timeout';
 *
 * async function main() {
 *     const res = await fetchTimeout('https://www.vg.no/iris-vg/sweet-endpoint', {
 *         headers: {
 *             'x-fancy-pants': true,
 *         },
 *         timeout: 5000
 *     });
 *
 *     const json = await res.json();
 * }
 *
 */
function fetchTimeout(endpoint, { timeout = 2000, ...options }) {
    return timeOutPromise(fetch(endpoint, { ...options }), timeout);
}

function timeOutPromise(promise, timeout) {
    return new Promise((resolve, reject) => {
        let didTimeOut = false;

        const timer = setTimeout(() => {
            didTimeOut = true;

            reject(new Error('Request timed out'));
        }, timeout);

        return promise
            .then((res) => {
                clearTimeout(timer);

                if (!didTimeOut) {
                    resolve(res);
                }
            })
            .catch((err) => {
                if (didTimeOut) {
                    // rejection has already happened
                    return;
                }

                reject(err); // reject with fetch error
            });
    });
}

export default fetchTimeout;



/** WEBPACK FOOTER **
 ** ./src/utils/fetch-timeout.js
 **/